import React, { useState, useEffect, useContext } from 'react'
import moment from 'moment'
import { navigate } from 'gatsby'
import { Helmet } from 'react-helmet'

import styled from 'styled-components'
import { AppContext, useWithAuth } from '../../containers/App'

import Button from '../../components/Button'
import Heading from '../../components/Heading'
import Layout from '../../components/Layout'
import colors from '../../styles/colors'

import { ListedSurvey, Users } from './utils'

// @ts-ignore @todo add apprioprate declaration file
import addIcon from '../../images/addIcon.svg'
// @ts-ignore @todo add apprioprate declaration file
import editIcon from '../../images/grayEditIcon.svg'
// @ts-ignore @todo add apprioprate declaration file
import shareIconUp from '../../images/shareIconUp.svg'
import { Hidden } from '../../styles/Shared'

function SurveyList() {
  const endpoint = '/form/rest/survey/list'
  const normalizeDate = (date) => moment(date).format('DD-MM-YYYY')
  const user = useContext(AppContext)
  const withAuth = useWithAuth()
  const [surveys, setSurveys] = useState<Array<ListedSurvey>>([])
  const [users, setUsers] = useState<Users[]>()

  const fetchSurveys = async () => {
    const result = await withAuth(endpoint, {
      method: 'GET',
    })
    return result
  }
  const fetchUsers = async (minId, maxId, user) => {
    const result = await withAuth(`/user/rest/user/search`, {
      method: 'POST',
      payload: {
        filters: {
          minId,
          maxId,
          unitId: user.unitId,
        },
        meta: {
          limit: maxId + 5,
          page: 0,
          total: 0,
        },
      },
    })
    return result
  }
  const fetchData = async () => {
    try {
      const result = await fetchSurveys()
      setSurveys(result)
    } catch {
      //notify('Nie udało się pobrać ankiety', 'error')
    }
  }
  const fetchUserData = async () => {
    try {
      const minId = Math.min(...surveys.map((survey) => survey.userId))
      const maxId = Math.max(...surveys.map((survey) => survey.userId))
      const resultUsers = await fetchUsers(minId, maxId, user)
      setUsers(resultUsers.models)
    } catch {
      //notify('Nie udało się pobrać ankiety', 'error')
    }
  }
  useEffect(() => {
    fetchData()
  }, [])
  useEffect(() => {
    surveys.length !== 0 ? fetchUserData() : null
  }, [surveys])
  return (
    <Layout>
      <Helmet htmlAttributes={{ lang: 'pl-PL' }}>
        <title>Ankiety</title>
      </Helmet>
      <Heading title="Ankiety">
        <Button
          link="/app/surveys/add"
          label="Nowa ankieta"
          icon={addIcon}
          width="auto"
          altTag=""
          srText=""
          imgAriaHidden={true}
        />
      </Heading>
      <SurveysWrapper>
        {surveys?.map((survey) => (
          <SurveyWrapper key={survey.id}>
            <div
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/app/surveys/info/${survey.id}`)}
              role="link"
              aria-label={`Nazwa ankiety: ${survey.title} Autor: ${
                users?.find((user) => user.id === survey.userId)
                  ? [
                      users?.find((user) => user.id === survey.userId)
                        ?.firstName,
                      users?.find((user) => user.id === survey.userId)
                        ?.lastName,
                    ]
                  : 'Administrator'
              } Data utworzenia: ${normalizeDate(survey.creationDate)}`}
            >
              <span aria-hidden>{survey.title}</span>
              <AuthorInfo>
                <label aria-hidden role="none">
                  Autor:
                </label>
                {users?.find((user) => user.id === survey.userId) ? (
                  <>
                    <StyledSpan>
                      {
                        users?.find((user) => user.id === survey.userId)
                          ?.firstName
                      }
                    </StyledSpan>
                    <StyledSpan>
                      {
                        users?.find((user) => user.id === survey.userId)
                          ?.lastName
                      }
                    </StyledSpan>
                  </>
                ) : (
                  <StyledSpan>{`Administrator`}</StyledSpan>
                )}
                <StyledLabel aria-hidden role="none">
                  Data utworzenia:
                </StyledLabel>
                <StyledSpan aria-hidden role="none">
                  {normalizeDate(survey.creationDate)}
                </StyledSpan>
              </AuthorInfo>
            </div>
            <AnswersInfo
              aria-label={`${survey.surveyAnsweredCount} Wypełnionych`}
            >
              <span aria-hidden role="none">
                {survey.surveyAnsweredCount}
              </span>
              <label aria-hidden role="none">
                Wypełnionych
              </label>
            </AnswersInfo>
            <AnswersInfo aria-label={`${survey.surveySentCount} Wysłanych`}>
              <span aria-hidden role="none">
                {survey.surveySentCount}
              </span>
              <label aria-hidden role="none">
                Wysłanych
              </label>
            </AnswersInfo>
            <ButtonWrapper>
              {survey.editable && (
                <TextButton
                  onClick={() => navigate(`/app/surveys/${survey.id}`)}
                >
                  <Hidden>Edytuj ankietę</Hidden>
                  <StyledImg
                    alt=""
                    src={editIcon}
                    aria-hidden="true"
                  ></StyledImg>
                </TextButton>
              )}
              <TextButton
                onClick={() => navigate(`/app/surveys/send/${survey.id}`)}
              >
                <Hidden>Wyślij ankietę</Hidden>
                <StyledImg
                  alt=""
                  src={shareIconUp}
                  aria-hidden="true"
                ></StyledImg>
              </TextButton>
            </ButtonWrapper>
          </SurveyWrapper>
        ))}
      </SurveysWrapper>
    </Layout>
  )
}
const SurveysWrapper = styled.div`
  margin: 1rem 5rem;
`

const StyledLabel = styled.label`
  margin-left: 0.5rem;
`

const ButtonWrapper = styled.div`
  display: flex;
  border-left: 1px solid black;
  justify-content: space-evenly;
`

const SurveyWrapper = styled.div`
  display: grid;
  min-height: 120px;
  max-height: 120px;
  grid-template-columns: 3fr 0.5fr 0.5fr 0.5fr;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: '. . . .';
  margin: 0.7rem 0;
  background: rgba(234, 234, 234, 1);
  border-left: 5px solid rgba(234, 234, 234, 0);
  &:hover {
    border-left: 5px solid ${colors.monza};
  }
  flex-direction: column;
  padding: 1rem;
  align-items: center;
  color: black;
  border-radius: 6px;
`
const AuthorInfo = styled.div`
  display: flex;
`
const AnswersInfo = styled.div`
  display: flex;
  flex-direction: column;
  border-left: 1px solid black;
  align-items: center;
`
const TextButton = styled.button`
  margin-top: 1rem;
  background: none;
  border: none;
  color: ${colors.monza};
  padding: 0;
  font-size: 12px;
  font-weight: 100;
  cursor: pointer;
`

const StyledSpan = styled.span`
  font-weight: 600;
  margin-left: 0.3rem;
`

const StyledImg = styled.img`
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  height: 24px;
  cursor: pointer;
  width: 24px;
`

export default SurveyList
